export default {
  landing: {
    features: "Features",
    solutions: "Solutions",
    pricing: "Pricing",
    waitlist: "Early Access",
    faq: "FAQ",
    contact: "Contact",
    about: "About",
    tools: "Free Tools",
  },
  upload: "Upload",
  history: "History",
  home: "Home",
  userMenu: {
    login: "Login",
    dashboard: "Dashboard",
    history: "History",
    logout: "Logout",
    themeMode: "Theme",
    themeLight: "Light",
    themeDark: "Dark",
    themeSystem: "System",
  },
};
